// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-comfy -> aion-management-comfy -> the-wellington
// Generated: 2026-10-22T20:06:22.492Z
// Counts: 5 design, 68 content, 61 slot group, 2 collection binding, 9 section, 5 style

export const designOverrides = {
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  },
  "design._site.font.accent": {
    "cssVariable": "--vibe-font-accent",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.body": {
    "cssVariable": "--vibe-font-body",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.font.mono": {
    "cssVariable": "--vibe-font-mono",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibility-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Accessibility",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Amenities",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Apply Now",
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.hours_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Office Hours</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.office_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Leasing Office</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.talk_label": {
    "overrideType": "VALUE",
    "customValue": "<h2>Let's Talk</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "faq-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Frequently Asked Questions</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Floor Plans",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<h2>Make Yourself at Home</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Gallery",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1><span style=\"font-size: 48px;\">Welcome To</span></h1><h1><span style=\"font-size: 48px;\"><span data-type=\"field-token\" data-field=\"property_name\"></span></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Interactive Map",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Neighborhood",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodsection.heading": {
    "overrideType": "VALUE",
    "customValue": "<h2>The heart of a growing community</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Pet Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.restrictions_heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Pet Restrictions</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.welcome_text": {
    "overrideType": "VALUE",
    "customValue": "<h3>Dogs &amp; Cats Welcome</h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Privacy Policy",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Embrace the Joy of Living in Your Dream Apartment</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Schedule a Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Sitemap",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Virtual Tour",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_fav_icon"
  },
  "accessibility-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.select_units_disclaimer": {
    "overrideType": "VALUE",
    "customValue": "*In Select Homes",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Transparent pricing for <span data-type=\"field-token\" data-field=\"property_name\"></span></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "fee-information-hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Fee Information</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<p>Spaciously Designed Apartments For Rent</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Explore apartments in your area</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/pet-friendly-apartments-beverly-nj::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Hyperlocal Page Title</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactive-map-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicy.heading": {
    "overrideType": "VALUE",
    "customValue": "<h3>Your pet belongs <em>here, too.</em></h3><h3></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacy-policy-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our wide array of spacious floor plans and find your perfect landing place in Hatboro at The Wellington. Our pet-friendly community provides a comfortable retreat with a host of upgrades plus friendly neighborhood vibes at a friendly price. Here you can get a workout in, relax in welcoming community spaces, or head to a pub nearby.</p><p>Situated near major highways and employers, The Wellington offers a lifestyle where work and play are right outside your door.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.heading": {
    "overrideType": "VALUE",
    "customValue": "Resident Portal",
    "generatedValue": null,
    "mappedField": null
  },
  "reviews-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>What residents are saying</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-form.talk_blurb": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_scheduletour_blurb"
  },
  "schedule-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemap-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Wellington in Hatboro, PA, relish upscale living with a range of thoughtfully designed floor plans—choose from one, two, or three bedrooms. Enjoy resort-style amenities, including a sparkling pool, fitness center, and a pet-friendly dog park, all tailored to elevate your lifestyle. Our community promises comfort and convenience, making every day extraordinary.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "apply-now-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Wellington in Hatboro, PA, where modern living meets comfort! Choose from our spacious one, two, or three-bedroom floor plans, complemented by top-notch amenities like a luxurious pool, fitness center, and pet-friendly areas. Your perfect home awaits—lease online today and elevate your lifestyle!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Wellington in Hatboro, PA, you'll find a variety of thoughtfully designed floor plans to suit every lifestyle. Choose from cozy one-bedroom retreats to spacious three-bedroom havens, all crafted for comfort. Browse our available apartment homes and discover the perfect layout that fits your needs today!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Picture yourself living at The Wellington in Hatboro, PA, where comfort meets style. Choose from one, two, or three-bedroom floor plans featuring stainless steel appliances, hardwood floors, and private balconies. Enjoy resort-style amenities like a sparkling pool, fitness center, and dog park—all designed for an enriching lifestyle.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.name": {
    "overrideType": "VALUE",
    "customValue": "The Wellington",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Wellington, your perfect haven in Hatboro, PA. Nestled amidst lush parks, esteemed schools, and vibrant community hubs, life here promises adventure and convenience. With spacious one, two, and three-bedroom floor plans, you're just moments away from exploring nearby nature reserves, cultural gems, and more. Check it out!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At The Wellington in charming Hatboro, PA, your furry friends are embraced! With room for two pets up to 100 lbs, our community caters to your lifestyle—complete with a dedicated pet policy. Live, relax, and enjoy the company of your beloved companions in a vibrant, welcoming atmosphere!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicycontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span>We value your trust. The following online privacy policy is intended to protect and secure the personally identifiable information (any information by which you can be identified) you provide to our organization online.&nbsp;</span></p><p><span>We collect information from visitors on our Web site through online requests including:</span></p><p><span>The information we collect online includes name, address, city, state, ZIP/postal code, telephone number, e-mail address. In order to continuously improve our service and meet your needs we may also ask you to provide information specific to your organization.&nbsp;</span></p><p><span>We use your information to communicate with you, and understand your needs to provide you with better service. We may use your information to complete a transaction, to update you on projects or to personalize our Web site for you. We also provide you the opportunity to remove your name from our mailing lists, if you desire to do so. Please review the corresponding section of this privacy policy below. n addition, we will not send you e-mail that you have not agreed to receive. We may periodically send you e-mail announcing news and event information.&nbsp;</span></p><p><span>We never sell, rent, lease or exchange your personal information with other organizations. We assure you that the identity of all who contact us through this Web site will be kept confidential.&nbsp;</span></p><p><span>We are committed to ensuring the security of your personal information. To prevent unauthorized access, maintain data accuracy, and ensure the proper use of information, we have established and implemented appropriate physical, electronic and managerial procedures to safeguard and secure the information we collect online.&nbsp;</span></p><p><span>From time to time, we may send a “cookie” to your computer. A cookie is a small piece of data that is sent to your browser from a Web server and stored on your computer’s hard drive. A cookie can’t read data off your hard drive or read cookie files created by other sites. Cookies do not damage your system. We use cookies to recognize you when you return to our sites, or to identify which areas of our network of Web sites you have visited. We may use this information to better personalize the content you see on our sites. Many Web sites place cookies on your hard drive. You can choose whether to accept cookies by changing the settings of your browser. Your browser can refuse all cookies, or show you when a cookie is being sent. If you choose not to accept these cookies, your experience at our site and other Web sites may be diminished and some features may not work as intended.&nbsp;</span></p><p><span>This Web site links to documents located on Web sites maintained by other organizations or individuals. Once you access a link to another Web site, please be aware that we are not responsible for the privacy practices or the content of such Web sites.&nbsp;</span></p><p><span>We give you the opportunity to remove your name from our postal mailing list so that you do not receive any future communications. If you desire to permanently remove your name, you can contact us. If you determine that our information about you is inaccurate or it has changed, you may also modify information by contacting customer service.&nbsp;</span></p><p><span>If you have comments or questions about our online privacy policy, or would like more information about us, or are experiencing technical trouble, please contact us.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "resident-access-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to The Wellington, where comfort meets convenience in Hatboro, PA. Our diverse floor plans—spacious one, two, and three-bedroom options—cater to all lifestyles. Access your resident portal now to effortlessly pay rent, schedule maintenance, and enhance your living experience in our vibrant community. Your home awaits!</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "residentaccess.app_heading": {
    "overrideType": "VALUE",
    "customValue": "Download the Loft Resident Mobile App",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>At The Wellington in Hatboro, PA, our thoughtfully designed one, two, and three-bedroom apartments offer the perfect blend of comfort and style. Ready to envision your new home? Schedule a tour today and hear firsthand from our residents about what life is like in our vibrant community!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "thank-you-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Thank You",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyoucontent.body": {
    "overrideType": "VALUE",
    "customValue": "<p><span> <span>Thank you for your submission! At The Wellington in Hatboro, PA, we offer stylish one, two, and three-bedroom floor plans designed for your comfort. Our team is excited to connect with you soon and help you find your perfect home in our vibrant community. Stay tuned!</span> </span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-hero.blurb": {
    "overrideType": "VALUE",
    "customValue": "<p>At The Wellington in Hatboro, PA, diverse floor plans await you—from cozy one-bedrooms to spacious three-bedrooms. Each apartment offers a perfect blend of style and comfort. Don't just imagine your new home; take a virtual tour and see what luxury living looks like today!</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/apply-now"
      }
    }
  },
  "hero.feature_slide_3": {
    "sourceIndex": 23,
    "fieldOverrides": null
  },
  "residentaccess.login_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "label": {
        "type": "VALUE",
        "customValue": "Access Resident Portal Login"
      }
    }
  },
  "amenitieslist.in_home_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-6855-728a-ab5a-b7f1864a9021.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Kitchen with wooden cabinets, stainless steel appliances, and a white subway tile backsplash."
      }
    }
  },
  "amenitieslist.indoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-9758-7752-bd8a-9deb085abb09.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Indoor fitness center with treadmills, elliptical machines, weights, and a bench"
      }
    }
  },
  "amenitieslist.indoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-e982-718b-8346-71210eeabe6f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor resident fitness center with weight machines, a cardio bike, and free weights."
      }
    }
  },
  "amenitieslist.indoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026e-c93f-7120-ac05-087818ae4cf0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Gym with treadmills, ellipticals, weight bench, and dumbbells."
      }
    }
  },
  "amenitieslist.indoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-f3c6-72ff-86cc-8fe84c81b37d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Living room with gray sectional sofa, rug, coffee table, TV, and dining area."
      }
    }
  },
  "amenitieslist.inHomePhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-42c5-72ec-ae7f-cf8febe9e054.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "U-shaped kitchen with maple cabinets, stainless steel fridge, dishwasher, and microwave."
      }
    }
  },
  "amenitieslist.inHomePhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-3978-75af-b922-f2da22cefceb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Furnished living room in an apartment with a gray tufted sofa, blue chair, ottoman, and wood cabinet."
      }
    }
  },
  "amenitieslist.inHomePhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-db70-711e-81bd-03749bead85d.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Bedroom in an apartment with a wooden bed, beige bedding, a double window with blinds, and an open closet."
      }
    }
  },
  "amenitieslist.neighborhood_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-a3d7-76b4-9ec3-c3f461a4df7e.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Exterior of a brick apartment building with a central blue door and multiple windows."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-db6e-7117-b86f-7ca04ccc5dfc.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior brick apartment building with leasing center sign and landscaped walkway."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-50fe-714a-9ecb-8389838decf1.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Brick multifamily building facade with central blue front door, steps, and adjacent windows."
      }
    }
  },
  "amenitieslist.neighborhoodPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-52eb-73f0-a3a0-3703675dbf86.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of a brick apartment building with trimmed shrubs and a sidewalk."
      }
    }
  },
  "amenitieslist.outdoor_photo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-8dcf-741f-9b02-8a3652861055.webp"
      },
      "alt": {
        "type": "GENERATOR",
        "generatedValue": "Outdoor apartment pool with lounge chairs and orange umbrellas."
      }
    }
  },
  "amenitieslist.outdoorPhoto1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-4e8b-747a-bc0f-3067eb822f12.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Aerial view of a community pool with orange umbrellas and lounge chairs."
      }
    }
  },
  "amenitieslist.outdoorPhoto2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-6517-72fd-9aad-f444553eab20.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor community patio with picnic tables, grills, and a fenced grassy area."
      }
    }
  },
  "amenitieslist.outdoorPhoto3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto/property/6767906449166357/019d026f-5097-705b-931c-d153a29c93b3.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Dog park with a tunnel, agility ramp, and seating."
      }
    }
  },
  "feesheet.admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": ""
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.amenity_renewal": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Amenity Renewal"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$150"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Annual"
      }
    }
  },
  "feesheet.application": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Application Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.buyout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Buy-Out Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "1 Month's Rent"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.custom_situational": {
    "sourceIndex": null,
    "fieldOverrides": {
      "amount": {
        "type": "VALUE",
        "customValue": "350"
      },
      "name": {
        "type": "VALUE",
        "customValue": "Admin Fee"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Assessed per occurrence for any modification to the Lease Agreement, including but not limited to the addition, removal, or substitution of any leaseholder or occupant."
      }
    }
  },
  "feesheet.electric": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Electric"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.gas": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Gas"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.late": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Late Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "10%"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.lockout": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Lockout Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$75"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.month_to_month": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Month To Month"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.nsf": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "NSF Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.pet_fee": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$350"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Per pet. Max 2."
      }
    }
  },
  "feesheet.pet_rent": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$50"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.pet_rent_2nd": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Pet Rent — 2nd Pet"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$25"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.reservation": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Reservation Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$200"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.security": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Security Deposit"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$750*"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      },
      "cost_detail": {
        "type": "VALUE",
        "customValue": "Deposit amount applies with approved credit and may be higher for conditional approvals"
      }
    }
  },
  "feesheet.transfer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Transfer Fee"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$500"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Per Occurrence"
      }
    }
  },
  "feesheet.trash": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Trash Service"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$12"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_admin": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility Admin / Billing"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$4.66"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "feesheet.utility_setup": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility New Account"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "$10"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "One-Time"
      }
    }
  },
  "feesheet.water": {
    "sourceIndex": null,
    "fieldOverrides": {
      "name": {
        "type": "VALUE",
        "customValue": "Utility — Water & Sewer"
      },
      "amount": {
        "type": "VALUE",
        "customValue": "Usage-Based (Utilities)"
      },
      "frequency": {
        "type": "VALUE",
        "customValue": "Monthly"
      }
    }
  },
  "hero.feature_slide_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-3978-75af-b922-f2da22cefceb.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Furnished living room in an apartment with a gray tufted sofa, blue chair, ottoman, and wood cabinet."
      }
    }
  },
  "hero.feature_slide_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-e70f-7582-b73f-e329b928b6a9.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor communal swimming pool with orange umbrellas and lounge chairs."
      }
    }
  },
  "hero.feature_slide_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-e982-718b-8346-71210eeabe6f.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Indoor resident fitness center with weight machines, a cardio bike, and free weights."
      }
    }
  },
  "hero.feature_slide_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026f-42c5-72ec-ae7f-cf8febe9e054.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "U-shaped kitchen with maple cabinets, stainless steel fridge, dishwasher, and microwave."
      }
    }
  },
  "neighborhoodhighlights.day_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5ae5-760c-9159-ddf75fc2446c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Jones'n Bagels"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Cafe & Breakfast"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Breakfast and lunch spot offering bagel sandwiches, plus coffee, cold brew and vegan options."
      }
    }
  },
  "neighborhoodhighlights.day_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-6ee3-738d-9306-0c2d9e648d7d.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Willow Grove Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Shopping & Retail"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.2"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "More than 130 retailers in a 3-story shopping mall with Victorian-era inspired decor & a carousel."
      }
    }
  },
  "neighborhoodhighlights.day_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-aa76-723b-bf59-e1fc55e2a403.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Warminster Community Park"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Park & Outdoors"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "3.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Large park featuring walking trails, a picnic area, a pond & a playground pavilion."
      }
    }
  },
  "neighborhoodhighlights.day_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5afd-7245-b38d-4ff6b8a47731.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Greek Korner"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dining"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.1"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Greek eatery featuring lamb gyros, chicken souvlaki and moussaka."
      }
    }
  },
  "neighborhoodhighlights.day_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7d0e-73e8-80dc-a12e18852c7b.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Abington Art Center"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Arts & Culture"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.6"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sculpture gardens and walking trails feature at this art center with events, classes, and a treehouse."
      }
    }
  },
  "neighborhoodhighlights.day_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-9951-762f-99d5-aca48181c6ee.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Horsham Athletic Club"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Fitness & Recreation"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "2.8"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Clean athletic club offering a variety of workouts from classes to yoga to personal training."
      }
    }
  },
  "neighborhoodhighlights.night_poi_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-60af-724e-acd1-64d4e0211d2f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Towey's Hatboro Tavern"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bar & Nightlife"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.1"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Lively neighborhood bar with karaoke, trivia nights, and bar food such as wings and cheesesteaks."
      }
    }
  },
  "neighborhoodhighlights.night_poi_2": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-8320-72fd-86a6-83b1f36523ae.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ardmore Music Hall"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Live Music"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "8.5"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Intimate venue featuring touring bands, cover acts and a bar."
      }
    }
  },
  "neighborhoodhighlights.night_poi_3": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-60ae-779a-ac71-5d77a95fe0ec.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Ming's Restaurant"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Dinner"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.1"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "BYOB Asian bistro with a well-lit dining room & a menu of classic Chinese dishes & Korean noodles."
      }
    }
  },
  "neighborhoodhighlights.night_poi_4": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7bb8-720e-a48e-6c14dd26259f.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Tilted 10"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Entertainment & Late-Night"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.0"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Sprawling entertainment center featuring bowling, mini golf, laser tag, arcade games and more."
      }
    }
  },
  "neighborhoodhighlights.night_poi_5": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-7b9d-73b0-ad04-c5ea1587625a.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Keswick Theatre"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Theater & Cinema"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "4.4"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Built in 1928 as a vaudeville/movie theater, this 1,300-seat space now hosts diverse music acts."
      }
    }
  },
  "neighborhoodhighlights.night_poi_6": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "GENERATOR",
        "generatedValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019d026d-5ae4-739d-b0f6-33d4466eca7c.webp"
      },
      "name": {
        "type": "GENERATOR",
        "generatedValue": "Lochel's Bakery"
      },
      "category": {
        "type": "GENERATOR",
        "generatedValue": "Bakery & Dessert"
      },
      "distance": {
        "type": "GENERATOR",
        "generatedValue": "1.2"
      },
      "description": {
        "type": "GENERATOR",
        "generatedValue": "Bakery focusing on special-occasion cakes also offers cupcakes, cookies, pies & pastries."
      }
    }
  },
  "propertyoverview.card1_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/019fd931-6bb2-723d-aecb-651393e0f1b8.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": ""
      }
    }
  },
  "propertyoverview.card2_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-a67e-7631-b52d-29013b4cc028.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Exterior view of brick apartment buildings with manicured lawns and a street in front."
      }
    }
  },
  "propertyoverview.card3_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166357/01a1647b-aebf-734d-83f8-795cd642f2a0.webp"
      },
      "alt": {
        "type": "VALUE",
        "customValue": "Outdoor swimming pool with lounge chairs and orange umbrellas."
      }
    }
  }
};

export const collectionBindingOverrides = {
  "homegallerypreview.photos": {
    "limit": 4,
    "hiddenIds": null,
    "orderedIds": [
      "custom_57cb3065-d2a6-4ce0-8e00-903493e6515a",
      "custom_d9b34934-5841-4f86-b162-1a92d2995021",
      "custom_7cbf025e-fe6b-417c-957c-4dc022e80059",
      "custom_c58673a4-ba60-4285-a258-ea7df3b1da23",
      "custom_446d4cfc-089f-49da-82d7-7efce06d98c4",
      "custom_738af29c-121e-461c-abd8-cead0f3171d8",
      "custom_2988bd95-ee12-4289-80da-6a9e9ef5a2ac",
      "custom_0e31b158-f2dc-4f3f-a1be-2ba08137ac95",
      "custom_4ac2e2d0-1e4d-4b5a-806d-79bf753d9763",
      "custom_8185722d-e7f1-49cf-88f1-5c031f98f19a",
      "custom_4988cc8a-8ff1-44ca-8969-9b97d2562b22",
      "custom_ce41f38f-67ed-404b-bbed-af4a1053e11e",
      "custom_4aa2cdbc-c02d-4e59-b8b5-40ee1d305f32",
      "custom_16ab4946-fe6c-4497-8c36-327873d4c462",
      "custom_ef4d2f77-ea93-424a-bb73-0d8bc1ae010a",
      "custom_d39cc56b-528b-4c17-8c60-43a5662269d9",
      "custom_5cb91a03-c777-4420-9e89-0e419bbfdd26",
      "custom_6b0e2588-b83d-4190-8d58-35114524cac4",
      "custom_376aef75-8d08-472b-a831-ca965311df8a",
      "custom_25ea2820-a4c5-41a9-a8d5-57bf0093c682",
      "custom_cec65b6a-1700-4ebc-b37d-5785dbce6d40",
      "custom_4d03eab9-3696-4e3d-be8f-0e0c3907ab7f",
      "custom_ea031685-5775-4bf2-ad64-154d0d6a9a8b",
      "custom_7f0c51c9-49e7-487f-b226-60b4334730da",
      "custom_40bb0083-be6f-451a-8e91-a5007e54d4ae",
      "custom_45e203a9-869e-44fe-8222-6c1ab51e6200",
      "custom_001ff465-faa8-4837-b6b4-8473355c4a3c",
      "custom_78fcc9da-d88c-42d4-8ceb-9aa233b8a224",
      "custom_8371a3ca-4adc-4c6b-ac59-27dc7166bf01",
      "custom_994826db-d8b9-463d-8fa9-0fe73a84e0b0"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "photogallery.images": {
    "limit": null,
    "hiddenIds": [
      "custom_8371a3ca-4adc-4c6b-ac59-27dc7166bf01"
    ],
    "orderedIds": [
      "custom_57cb3065-d2a6-4ce0-8e00-903493e6515a",
      "custom_2988bd95-ee12-4289-80da-6a9e9ef5a2ac",
      "custom_0e31b158-f2dc-4f3f-a1be-2ba08137ac95",
      "custom_4ac2e2d0-1e4d-4b5a-806d-79bf753d9763",
      "custom_7cbf025e-fe6b-417c-957c-4dc022e80059",
      "custom_8371a3ca-4adc-4c6b-ac59-27dc7166bf01",
      "custom_8185722d-e7f1-49cf-88f1-5c031f98f19a",
      "custom_4988cc8a-8ff1-44ca-8969-9b97d2562b22",
      "custom_ce41f38f-67ed-404b-bbed-af4a1053e11e",
      "custom_4aa2cdbc-c02d-4e59-b8b5-40ee1d305f32",
      "custom_16ab4946-fe6c-4497-8c36-327873d4c462",
      "custom_ef4d2f77-ea93-424a-bb73-0d8bc1ae010a",
      "custom_d39cc56b-528b-4c17-8c60-43a5662269d9",
      "custom_5cb91a03-c777-4420-9e89-0e419bbfdd26",
      "custom_6b0e2588-b83d-4190-8d58-35114524cac4",
      "custom_376aef75-8d08-472b-a831-ca965311df8a",
      "custom_25ea2820-a4c5-41a9-a8d5-57bf0093c682",
      "custom_cec65b6a-1700-4ebc-b37d-5785dbce6d40",
      "custom_4d03eab9-3696-4e3d-be8f-0e0c3907ab7f",
      "custom_7f0c51c9-49e7-487f-b226-60b4334730da",
      "custom_40bb0083-be6f-451a-8e91-a5007e54d4ae",
      "custom_d9b34934-5841-4f86-b162-1a92d2995021",
      "custom_994826db-d8b9-463d-8fa9-0fe73a84e0b0",
      "custom_738af29c-121e-461c-abd8-cead0f3171d8",
      "custom_ea031685-5775-4bf2-ad64-154d0d6a9a8b",
      "custom_c58673a4-ba60-4285-a258-ea7df3b1da23",
      "custom_446d4cfc-089f-49da-82d7-7efce06d98c4",
      "custom_001ff465-faa8-4837-b6b4-8473355c4a3c",
      "custom_45e203a9-869e-44fe-8222-6c1ab51e6200",
      "custom_78fcc9da-d88c-42d4-8ceb-9aa233b8a224"
    ],
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "elise-chatbot",
      "blockId": "elise-chatbot",
      "position": 0
    },
    {
      "sectionId": "perq-floor-plan",
      "blockId": "perq-floor-plan",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 9
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 9
    }
  ]
};

export const styleOverrides = {
  "_template:hyperlocal::_section.block:apartment-sync": {
    "properties": {
      "paddingBottom": "50px",
      "backgroundColor": "#ffffff"
    }
  },
  "apartmentsyncsection.block": {
    "properties": {
      "paddingBottom": "30px"
    }
  },
  "hero.name": {
    "properties": {
      "paddingBottom": "50px"
    }
  },
  "propertyoverview.blurb": {
    "properties": {
      "fontWeight": "300"
    }
  },
  "residentaccess.app_heading": {
    "properties": {
      "fontWeight": "700"
    }
  }
};
